import React, { forwardRef } from 'react';
import styled from 'styled-components';
import { GetColor } from 'venn-ui-kit';
import { type HTMLProps } from '../factory';
import { useAppPrintMode } from '../../../../print';
import { BlockHeaderControls } from './block-header-controls';
import { cn } from '@/lib/utils';

export type BlockHeaderTopContainerElement = React.ElementRef<'div'>;
export interface BlockHeaderTopContainerProps extends HTMLProps<'div'> {
  children?: React.ReactNode;
  id: string;
}

export const BlockHeaderTopContainer = forwardRef<BlockHeaderTopContainerElement, BlockHeaderTopContainerProps>(
  (props, ref) => {
    const { children, id } = props;
    const { inPrintModeOrReportLab } = useAppPrintMode();

    return (
      <Container ref={ref} inPrintMode={inPrintModeOrReportLab}>
        <div
          className={cn(
            'flex-1',
            inPrintModeOrReportLab
              ? 'pt-[0.7rem] pr-[0.7rem] pb-[0.3rem] pl-[0.7rem]'
              : 'pt-[13px] pr-[15px] pb-[5px] pl-[15px]',
          )}
        >
          {children}
        </div>
        <div>
          <BlockHeaderControls id={id} />
        </div>
      </Container>
    );
  },
);

BlockHeaderTopContainer.displayName = 'BlockHeaderTopContainer';

const Container = styled.div<{ inPrintMode: boolean }>`
  display: flex;

  label {
    font-size: 14px;
    padding-right: 5px;
  }

  border-bottom: 1px solid ${GetColor.GreyScale.Grey40};
`;
